/**
 * @author HungNS
 */
"use strict";
import i18n from '@/lang/i18n'
import Config from "@/services/Config";

var self = new Object();

self.SERVICE_TYPE = {
  SOCIAL: "7",
  AMS: "0",
  BO: "4",
  NTD_FX: "21",
  CRYPTO_FX: "31"
};

self.ALL = "All";

self.BENEFIC_OWNER_TYPE = {
  UNDEFINED: -1,
  INDIVIDUAL: 0,
  CORPORATION: 1,
  OTHER: 9
}

self.REPORT_TYPE = {
  DAILY: "d",
  MONTHLY: "m",
  YEARLY: "y",
};

self.ACCOUNT_TYPE_TRANSFER = {
  ST: "1",
  BO: "2",
  NTDFX: "3",
  AMS: "4",
  CRYPTOFX: "5",
};

self.FLAG = {
  ACTIVE: "1",
  INACTIVE: "0",
};
self.CUSTOMER_TYPE = {
  INDIVIDUAL: "0",
  CORPORATION: "1",
};

self.KICKBACK_TYPE = {
  WAITING: "3",
  DEPOSIT_COMPLETE: "4",
  TRADED_COMPLETE: "5",
};

self.TRANSACTION_TYPE = {
  DEPOSIT: "0",
  WITHDRAWAL: "1",
  TRANSFER: "2",
  CASH_BACK: "3",
  OTHER: "4",
  SOCIAL_AFFILIATE_IN: "5",
  SOCIAL_AFFILIATE_OUT: "6",
  SWAP_IN: "7",
  SWAP_OUT: "8",
  TRADING_PROFIT: "9",
  TRADING_LOSS: "10",
  SOCIAL_FEE_IN: "11",
  SOCIAL_FEE_OUT: "12",
  ADJUST_IN: "17",
  ADJUST_OUT: "18",
  ADJUST_SPOT_PL: "20",
  ADJUST_SWAP_PL: "21",
  ADJUST_BALANCE: "22",
  ADJUST_TRANSFER: "23",
  ADJUST_BALANCE_OUT: "24",
  ADJUST_TRANSFER_OUT: "25",
};

self.TRANSACTION_METHOD = {
  BANKWIRE: "1",
  VITUAL_ACCOUNT: "21",
  DIRECT_DEPOSIT: "22",
};

self.getMapTransactionType = function() {
  var result = [
    {
      key: self.TRANSACTION_TYPE.DEPOSIT,
      value: "history.transaction.type.deposit",
    },
    {
      key: self.TRANSACTION_TYPE.WITHDRAWAL,
      value: "history.transaction.type.withdrawl",
    },
    {
      key: self.TRANSACTION_TYPE.TRANSFER,
      value: "history.transaction.type.transfer",
    },
    {
      key: self.TRANSACTION_TYPE.CASH_BACK,
      value: "history.transaction.type.cashback",
    },
    {
      key: self.TRANSACTION_TYPE.OTHER,
      value: "history.transaction.type.other",
    },
  ];
  return result;
};

self.getMapInvestExperiment = function() {
  var result = [
    {
      key: -1,
      value: "trs.front.crypto.registration.please_choose",
    },
    {
      key: 6,
      value: "trs.front.crypto.registration.over_5 _years",
    },
    {
      key: 5,
      value: "trs.front.crypto.registration.less_than_5_years",
    },
    {
      key: 4,
      value: "trs.front.crypto.registration.less_than_4_years",
    },
    {
      key: 3,
      value: "trs.front.crypto.registration.less_than_3_years",
    },
    {
      key: 2,
      value: "trs.front.crypto.registration.less_than_2_years",
    },
    {
      key: 1,
      value: "trs.front.crypto.registration.less_than_1_years",
    },
    {
      key: 0,
      value: "trs.front.crypto.registration.no_experience",
    },
  ];
  return result;
};

self.getMapInvestExperimentSub = function() {
  var result = [
    {
      key: -1,
      value: "trs.front.crypto.registration.please_choose",
    },
    {
      key: 1,
      value: "trs.front.crypto.regis.invest.exp.less_than_1_month",
    },
    {
      key: 2,
      value: "trs.front.crypto.regis.invest.exp.less_than_2_month",
    },
    {
      key: 3,
      value: "trs.front.crypto.regis.invest.exp.less_than_3_month",
    },
    {
      key: 4,
      value: "trs.front.crypto.regis.invest.exp.less_than_4_month",
    },
    {
      key: 5,
      value: "trs.front.crypto.regis.invest.exp.less_than_5_month",
    },
    {
      key: 6,
      value: "trs.front.crypto.regis.invest.exp.less_than_6_month",
    },
    {
      key: 7,
      value: "trs.front.crypto.regis.invest.exp.less_than_7_month",
    },
    {
      key: 8,
      value: "trs.front.crypto.regis.invest.exp.less_than_8_month",
    },
    {
      key: 9,
      value: "trs.front.crypto.regis.invest.exp.less_than_9_month",
    },
    {
      key: 10,
      value: "trs.front.crypto.regis.invest.exp.less_than_10_month",
    },
    {
      key: 11,
      value: "trs.front.crypto.regis.invest.exp.less_than_11_month",
    },
    {
      key: 12,
      value: "trs.front.crypto.regis.invest.exp.less_than_12_month",
    },
  ];
  return result;
};

self.getMapTransactionMethod = function() {
  var result = [
    {
      key: self.TRANSACTION_METHOD.BANKWIRE,
      value: "history.transaction.method.bankwire",
    },
    {
      key: self.TRANSACTION_METHOD.VITUAL_ACCOUNT,
      value: "history.transaction.type.vitual_account",
    },
    {
      key: self.TRANSACTION_METHOD.DIRECT_DEPOSIT,
      value: "history.transaction.type.direct_deposit",
    },
  ];
  return result;
};

self.getMapDepositStatus = function() {
  var result = [
    {
      key: "5",
      value: "history.transaction.status.requesting",
    },
    {
      key: "6",
      value: "history.transaction.status.inprogress",
    },
    {
      key: "1",
      value: "history.transaction.status.success",
    },
    {
      key: "7",
      value: "history.transaction.status.cancel",
    },
  ];
  return result;
};

self.getMapCashBackStatus = function() {
  var result = [
    {
      key: "2",
      value: "history.transaction.status.inprogress",
    },
    {
      key: "1",
      value: "history.transaction.status.success",
    },
    {
      key: "0",
      value: "history.transaction.status.cancel",
    },
  ];
  return result;
};

self.getMapServiceType = function() {
  var result = [
    {
      key: self.SERVICE_TYPE.AMS,
      value: "report.cb.service.type.ams",
    },
    {
      key: self.SERVICE_TYPE.BO,
      value: "report.cb.service.type.bo",
    },
    {
      key: self.SERVICE_TYPE.SOCIAL,
      value: "report.cb.service.type.social",
    },
  ];
  return result;
};

self.getMapReportType = function() {
  var result = [
    {
      key: self.REPORT_TYPE.DAILY,
      value: "report.cb.report.type.d",
    },
    {
      key: self.REPORT_TYPE.MONTHLY,
      value: "report.cb.report.type.m",
    },
    {
      key: self.REPORT_TYPE.YEARLY,
      value: "report.cb.report.type.y",
    },
  ];
  return result;
};

self.getMapAccountTypeTransfersAll = function() {
  var result = [
    {
      key: self.ACCOUNT_TYPE_TRANSFER.NTDFX,
      value: ("report.cb.account.type.ntdfx"),
    },
    {
      key: self.ACCOUNT_TYPE_TRANSFER.ST,
      value: ("report.cb.account.type.st"),
    },
    {
      key: self.ACCOUNT_TYPE_TRANSFER.BO,
      value: ("report.cb.account.type.bo"),
    },
    {
      key: self.ACCOUNT_TYPE_TRANSFER.CRYPTOFX,
      value: ("report.cb.account.type.crypto"),
    },
    {
      key: self.ACCOUNT_TYPE_TRANSFER.AMS,
      value: ("report.cb.account.type.ams"),
    },
  ];
  return result;
};

self.getMapAccountTypePeriodReport = function() {
  var result = [
    {
      key: self.SERVICE_TYPE.NTD_FX,
      value: i18n.t("report.table.account.type.3"),
    },
    {
      key: self.SERVICE_TYPE.SOCIAL,
      value: i18n.t("report.table.account.type.1"),
    },
    {
      key: self.SERVICE_TYPE.BO,
      value: i18n.t("report.table.account.type.2"),
    },
    {
      key: self.SERVICE_TYPE.CRYPTO_FX,
      value: i18n.t("report.table.account.type.5"),
    },
    {
      key: self.SERVICE_TYPE.AMS,
      value: i18n.t("report.table.account.type.4"),
    },
  ];
  return result;
};


self.getKickbackType = function() {
  var result = [
    {
      key: self.KICKBACK_TYPE.TRADED_COMPLETE,
      value: "kickback.type.traded_complete",
    },
    {
      key: self.KICKBACK_TYPE.WAITING,
      value: "kickback.type.waiting",
    },
    {
      key: self.KICKBACK_TYPE.DEPOSIT_COMPLETE,
      value: "kickback.type.deposit_complete",
    },
  ];
  return result;
};

self.getMapBankAccount = function() {
  var result = [
    {
      key: "0001",
      value: "deposit.cb.bank_account.0001",
    },
    {
      key: "0009",
      value: "deposit.cb.bank_account.0009",
    },
    {
      key: "0005",
      value: "deposit.cb.bank_account.0005",
    },
    {
      key: "9900",
      value: "deposit.cb.bank_account.9900",
    },
    {
      key: "0036",
      value: "deposit.cb.bank_account.0036",
    },
    {
      key: "0033",
      value: "deposit.cb.bank_account.0033",
    },
    {
      key: "0038",
      value: "deposit.cb.bank_account.0038",
    },
  ];
  return result;
};

self.listBeneficOwner = [
  {
    key: "1",
    value: i18n.t("profile.benefit_ownder.yes"),
  },

  {
    key: "0",
    value: i18n.t("profile.benefit_ownder.no"),
  },
];

self.listBeneficOwnerType = [
  {
    key: 0,
    value: i18n.t("profile.benefit_owner.type.idv"),
  },

  {
    key: 1,
    value: i18n.t("profile.benefit_owner.type.corp"),
  },

  {
    key: 9,
    value: i18n.t("profile.benefit_owner.type.other"),
  }
];

self.listBeneficOwnerOtherOne = [
  {
    key: "0",
    value: i18n.t("profile.benefit_ownder_other.no"),
  },
  {
    key: "1",
    value: i18n.t("profile.benefit_ownder_other.yes"),
  },
];

self.listFinalAssets = [
  {
    key: "0",
    value: ("finalassets.less_than_3"),
  },

  {
    key: "1",
    value: ("finalassets.3_10"),
  },

  {
    key: "2",
    value: ("finalassets.10_25"),
  },

  {
    key: "3",
    value: ("finalassets.25_50"),
  },

  {
    key: "4",
    value: ("finalassets.50_100"),
  },

  {
    key: "5",
    value: ("finalassets.100_250"),
  },

  {
    key: "6",
    value: ("finalassets.250_500"),
  },

  {
    key: "7",
    value: ("finalassets.500_1000"),
  },
  {
    key: "8",
    value: ("finalassets.over_1000"),
  },
];

self.LIST_FINAL_ASSETS = [
  {
    key: -1,
    value: i18n.t('profile.label.please_select'),
  },
  {
    key: 0,
    value: i18n.t('finalassets.less_than_3'),
  },

  {
    key: 1,
    value: i18n.t('finalassets.3_10'),
  },

  {
    key: 2,
    value: i18n.t('finalassets.10_25'),
  },

  {
    key: 3,
    value: i18n.t('finalassets.25_50'),
  },

  {
    key: 4,
    value: i18n.t('finalassets.50_100'),
  },

  {
    key: 5,
    value: i18n.t('finalassets.100_250'),
  },

  {
    key: 6,
    value: i18n.t('finalassets.250_500'),
  },

  {
    key: 7,
    value: i18n.t('finalassets.500_1000'),
  },
  {
    key: 8,
    value: i18n.t('finalassets.over_1000'),
  },
];

self.listPicName = [
  {
    key: 0,
    value: ("profile.benefit_ownder.no"),
  },

  {
    key: 1,
    value: ("profile.benefit_ownder.yes"),
  },
];

self.getListServiceTypeTransfer = function() {
  var result = [
    {
      key: self.SERVICE_TYPE.AMS,
      value: ("transfer.dcb.service.type.ams"),
    },
    {
      key: self.SERVICE_TYPE.NTD_FX,
      value: ("transfer.cb.service.type.ntd_fx"),
    },
    {
      key: self.SERVICE_TYPE.SOCIAL,
      value: ("transfer.cb.service.type.social"),
    },
    {
      key: self.SERVICE_TYPE.BO,
      value: ("transfer.cb.service.type.bo"),
    },
    {
      key: self.SERVICE_TYPE.CRYPTO_FX,
      value: ("transfer.cb.service.type.crypto_fx"),
    },
  ];
  return result;
};

self.CSS_CLASS_BALANCE = [];
self.CSS_CLASS_BALANCE[1] = "col-md-6 col-xs-6 text-center text-success";
self.CSS_CLASS_BALANCE[2] = "col-md-5 col-xs-6 text-center text-success";
self.CSS_CLASS_BALANCE[3] = "col-md-4 col-xs-6 text-center text-success";
self.CSS_CLASS_BALANCE[4] = "col-md-3 col-xs-6 text-center text-success";

self.listGender = [
  {
    key: 0,
    value: ("profile.gender.female"),
  },

  {
    key: 1,
    value: ("profile.gender.male"),
  },
];

self.Events = {
  SITE_NAVIGATION: "site.navigating",
};

self.getMapAccountType = function() {
  var result = [
    {
      key: "1",
      value: ("bank.account.type.normal"),
    },
    {
      key: "2",
      value: ("bank.account.type.current_deposit"),
    },
    {
      key: "3",
      value: ("bank.account.type.saving_deposit"),
    },
  ];
  return result;
};
self.getMapQuestionSubject = function() {
  var result = {
    Structure: ("questionnaire.subject.structure.jp"),
    Method: ("questionnaire.subject.method.jp"),
    Outline: ("questionnaire.subject.outline.jp"),
    Risk: ("questionnaire.subject.risk.jp"),
    Calculation: ("questionnaire.subject.calculation.jp"),
  };
  return result;
};

self.READ_FLG = {
  READ: 1,
  UNREAD: 0,
};
self.LOGIN_NOTIFY = {
  ACTIVE: "3",
  MAIN_MAIL: "1",
  ADDITIONAL_MAIL: "2",
  INACTIVE: "0",
};

self.HREF_POSTAL_CODE_REFERENCE = Config.getPostalCodeReference();
self.RESULT_AJAX = {
  FAILED: "FAILED",
  SUCCESS: "SUCCESS",
  INVALID_VERSION: "INVALID_VERSION",
  INVALID_SERVICE: "INVALID_SERVICE",
  RECORD_NOT_FOUND: "RECORD_NOT_FOUND",
  INTERNAL_ERROR: "INTERNAL_ERROR",
};

self.listBoPurposeHedgeType = [
  {
    key: "",
    value: ("profile.label.please_select"),
  },
  {
    key: "0",
    value: ("profile.bopurposehedgetype.fx"),
  },

  {
    key: "1",
    value: ("profile.bopurposehedgetype.stock"),
  },

  {
    key: "2",
    value: ("profile.bopurposehedgetype.commodity"),
  },
  {
    key: "3",
    value: ("profile.bopurposehedgetype.foreign_currency"),
  },
  {
    key: "4",
    value: ("profile.bopurposehedgetype.corporate_bond"),
  },
];

self.mapSeflAssetsAmount = {
  "0": 1,
  "1": 2,
  "2": 5,
  "3": 12,
  "4": 25,
  "5": 50,
  "6": 125,
  "7": 250,
  "8": 500,
};

self.MESSAGE_KIND = {
  NOTIFICATION: 1,
  IMPORTANT: 2,
  CAMPAIGN: 3,
  SEMINAR: 4,
  MAINTENANCE: 5,
  OTHER: 9,
};
self.COUNTING_JAPAN_CURRENCY = {
  "100000000": "1億",
};

self.mapMessageKind = function() {
  var result = [
    {
      key: 0,
      value: "default.combo.box",
    },
    {
      key: self.MESSAGE_KIND.NOTIFICATION,
      value: "customer.news.messagekind.notification",
    },
    {
      key: self.MESSAGE_KIND.IMPORTANT,
      value: "customer.news.messagekind.important",
    },
    {
      key: self.MESSAGE_KIND.CAMPAIGN,
      value: "customer.news.messagekind.campaign",
    },
    {
      key: self.MESSAGE_KIND.SEMINAR,
      value: "customer.news.messagekind.seminar",
    },
    {
      key: self.MESSAGE_KIND.MAINTENANCE,
      value: "customer.news.messagekind.maintenance",
    },
    {
      key: self.MESSAGE_KIND.OTHER,
      value: "customer.news.messagekind.other",
    },
  ];
  return result;
};

self.getServiceTypeName = function(serviceTypeNumber, mapServiceType){
  let serviceName = '';
  Object.values(mapServiceType).forEach(element => {
    if(element.key == serviceTypeNumber) serviceName = element.value;
  });
  return serviceName;
};

self.mapSex = [
  {
    key: 1,
    value: ("step1.label.sex.male"),
  },
  {
    key: 0,
    value: ("step1.label.sex.female"),
  },
];

self.ONOFF = {
  ON: "on",
  OFF: "off",
};
self.mapYesNo = [
  {
    key: 1,
    value: ("screen.label.yes"),
  },
  {
    key: 0,
    value: ("screen.label.no"),
  },
];
self.listButtonAddResience = [
  {
    key: 0,
    value: ("screen.label.residence.addResidence.no"),
  },
  {
    key: 1,
    value: ("screen.label.residence.addResidence.yes"),
  },
];

self.listOccupation = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 1,
    value: ("occupation.companyExcutive"),
  },
  {
    key: 2,
    value: ("occupation.employee"),
  },
  {
    key: 3,
    value: ("occupation.governmentEmployee"),
  },
  {
    key: 4,
    value: ("occupation.organizationStaff"),
  },
  {
    key: 5,
    value: ("occupation.doctor_other_medicalExpert"),
  },
  {
    key: 6,
    value: ("occupation.lawyer_accountant_taxAccountant"),
  },
  {
    key: 7,
    value: ("occupation.schoolPersonnel"),
  },
  {
    key: 8,
    value: ("occupation.independentBusiness"),
  },
  {
    key: 9,
    value: ("occupation.parttimeEmployment"),
  },
  {
    key: 10,
    value: ("occupation.housewife_homedad"),
  },
  {
    key: 11,
    value: ("occupation.student"),
  },
  {
    key: 12,
    value: ("occupation.inoccupation"),
  },
];

self.listIndustryType = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 1,
    value: ("industryType.agriculture"),
  },
  {
    key: 2,
    value: ("industryType.forestIndustry"),
  },
  {
    key: 3,
    value: ("industryType.fisheryIndustry"),
  },
  {
    key: 4,
    value: ("industryType.miningIndustry"),
  },
  {
    key: 5,
    value: ("industryType.buildingIndustry"),
  },
  {
    key: 6,
    value: ("industryType.manufacturingIndustry"),
  },
  {
    key: 7,
    value: (
      "industryType.electricityGas_and_waterSupplyIndustry"
    ),
  },
  {
    key: 8,
    value: ("industryType.wholesaleRetail"),
  },
  {
    key: 9,
    value: (
      "industryType.informationAndCommunicationTechnologyIndustry"
    ),
  },
  {
    key: 10,
    value: ("industryType.traffic"),
  },
  {
    key: 11,
    value: ("industryType.financeAndInsuranceIndustry"),
  },
  {
    key: 12,
    value: ("industryType.realEstateIndustry"),
  },
  {
    key: 13,
    value: ("industryType.drinkingEndEating:LodgingIndustry"),
  },
  {
    key: 14,
    value: ("industryType.medicalWelfare"),
  },
  {
    key: 15,
    value: ("industryType.supportingLearningAndTeaching"),
  },
  {
    key: 16,
    value: ("industryType.officialBusiness"),
  },
  {
    key: 17,
    value: ("industryType.serviceIndustry"),
  },
  {
    key: 0,
    value: ("industryType.others"),
  },
];

self.listMajorIncomeObj = {
  PLEASE_SELECT: {
    key: -1,
    value: ("screen.label.please_select"),
  },
  EMPLOYMENT: {
    key: 1,
    value: ("majorIncome.employment"),
  },
  BUSINESS: {
    key: 2,
    value: ("majorIncome.business"),
  },
  INTEREST_ASHDIVIDEND_INVESTMENT: {
    key: 3,
    value: ("majorIncome.interest_ashDividend_investment"),
  },
  ANNUALPENSION_RETIREDPENSION: {
    key: 4,
    value: ("majorIncome.annualPension_retiredPension"),
  },
  NO_INCOME: {
    key: 6,
    value: ("majorIncome.no_income"),
  },
};

self.listFinalAssetsWithHeader = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 0,
    value: ("finalassets.less_than_3"),
  },
  {
    key: 1,
    value: ("finalassets.3_10"),
  },
  {
    key: 2,
    value: ("finalassets.10_25"),
  },
  {
    key: 3,
    value: ("finalassets.25_50"),
  },
  {
    key: 4,
    value: ("finalassets.50_100"),
  },
  {
    key: 5,
    value: ("finalassets.100_250"),
  },
  {
    key: 6,
    value: ("finalassets.250_500"),
  },
  {
    key: 7,
    value: ("finalassets.500_1000"),
  },
  {
    key: 8,
    value: ("finalassets.over_1000"),
  },
];

self.listHedgeType = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 0,
    value: ("screen.label.bopurposehedgetype.fx"),
  },
  {
    key: 1,
    value: ("screen.label.bopurposehedgetype.stock"),
  },
  {
    key: 2,
    value: ("screen.label.bopurposehedgetype.commodity"),
  },
  {
    key: 3,
    value: (
      "screen.label.bopurposehedgetype.foreign_currency"
    ),
  },
  {
    key: 4,
    value: ("screen.label.bopurposehedgetype.corporate_bond"),
  },
];

self.mapTinOption = [
  {
    key: 1,
    value: ("screen.label.residence.tin.optin1"),
  },
  {
    key: 2,
    value: ("screen.label.residence.tin.optin2"),
  },
];

self.mapSelfAssetsFlg = [
  {
    key: 1,
    value: ("screen.label.selfAssetsFlg.yes"),
  },
  {
    key: 0,
    value: ("screen.label.selfAssetsFlg.no"),
  },
];

self.mapDiscoverSource = [
  {
    key: 1,
    value: "当社ホームページ",
  },
  {
    key: 2,
    value: "他サイト",
  },
  {
    key: 8,
    value: "テレビCM",
  },
  {
    key: 3,
    value: "雑誌",
  },
  {
    key: 4,
    value: "新聞",
  },
  {
    key: 5,
    value: "家族の紹介",
  },
  {
    key: 6,
    value: "知人の紹介",
  },
  {
    key: 7,
    value: "ブログ",
  },
  {
    key: 0,
    value: "その他",
  },
];

self.mapExperience = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 6,
    value: ("step5.investment_experience.more_than_5_year"),
  },
  {
    key: 5,
    value: ("step5.investment_experience.less_than_5_year"),
  },
  {
    key: 4,
    value: ("step5.investment_experience.less_than_4_year"),
  },
  {
    key: 3,
    value: ("step5.investment_experience.less_than_3_year"),
  },
  {
    key: 2,
    value: ("step5.investment_experience.less_than_2_year"),
  },
  {
    key: 1,
    value: ("step5.investment_experience.less_than_1_year"),
  },
  {
    key: 0,
    value: ("step5.investment_experience.inexperience"),
  },
];

self.mapInvestExpSub = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 12,
    value: (
      "step5.investment_experience.sub.more_than_12_year"
    ),
  },
  {
    key: 11,
    value: (
      "step5.investment_experience.sub.less_than_11_year"
    ),
  },
  {
    key: 10,
    value: (
      "step5.investment_experience.sub.less_than_10_year"
    ),
  },
  {
    key: 9,
    value: (
      "step5.investment_experience.sub.less_than_9_year"
    ),
  },
  {
    key: 8,
    value: (
      "step5.investment_experience.sub.less_than_8_year"
    ),
  },
  {
    key: 7,
    value: (
      "step5.investment_experience.sub.less_than_7_year"
    ),
  },
  {
    key: 6,
    value: (
      "step5.investment_experience.sub.less_than_6_year"
    ),
  },
  {
    key: 5,
    value: (
      "step5.investment_experience.sub.less_than_5_year"
    ),
  },
  {
    key: 4,
    value: (
      "step5.investment_experience.sub.less_than_4_year"
    ),
  },
  {
    key: 3,
    value: (
      "step5.investment_experience.sub.less_than_3_year"
    ),
  },
  {
    key: 2,
    value: (
      "step5.investment_experience.sub.less_than_2_year"
    ),
  },
  {
    key: 1,
    value: (
      "step5.investment_experience.sub.less_than_1_year"
    ),
  },
];

self.listCorpJobType = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 21,
    value: ("corpJobType.finance"),
  },
  {
    key: 22,
    value: ("corpJobType.telecommunications"),
  },
  {
    key: 23,
    value: ("corpJobType.agriculture"),
  },
  {
    key: 24,
    value: ("corpJobType.energy"),
  },
  {
    key: 25,
    value: ("corpJobType.buildingIndustry"),
  },
  {
    key: 26,
    value: ("corpJobType.medicalProducts"),
  },
  {
    key: 27,
    value: ("corpJobType.ironAndSteel"),
  },
  {
    key: 28,
    value: ("corpJobType.food"),
  },
  {
    key: 29,
    value: ("corpJobType.electrical"),
  },
  {
    key: 30,
    value: ("corpJobType.automobile"),
  },
  {
    key: 31,
    value: ("corpJobType.mechanicalEquipment"),
  },
  {
    key: 32,
    value: ("corpJobType.otherManufacturing"),
  },
  {
    key: 33,
    value: ("corpJobType.trading"),
  },
  {
    key: 34,
    value: ("corpJobType.advertisement"),
  },
  {
    key: 35,
    value: ("corpJobType.newspaper"),
  },
  {
    key: 36,
    value: ("corpJobType.transportation"),
  },
  {
    key: 37,
    value: ("corpJobType.medicalInstitution"),
  },
  {
    key: 38,
    value: ("corpJobType.restaurantService"),
  },
  {
    key: 39,
    value: ("corpJobType.countryMunicipality"),
  },
  {
    key: 40,
    value: ("corpJobType.education"),
  },
  {
    key: 0,
    value: ("corpJobType.others"),
  },
];

self.listMonth = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 1,
    value: ("01_M"),
  },
  {
    key: 2,
    value: ("02_M"),
  },
  {
    key: 3,
    value: ("03_M"),
  },
  {
    key: 4,
    value: ("04_M"),
  },
  {
    key: 5,
    value: ("05_M"),
  },
  {
    key: 6,
    value: ("06_M"),
  },
  {
    key: 7,
    value: ("07_M"),
  },
  {
    key: 8,
    value: ("08_M"),
  },
  {
    key: 9,
    value: ("09_M"),
  },
  {
    key: 10,
    value: ("10_M"),
  },
  {
    key: 11,
    value: ("11_M"),
  },
  {
    key: 12,
    value: ("12_M"),
  },
];

self.listDay = [
  {
    key: -1,
    value: ("screen.label.please_select"),
  },
  {
    key: 1,
    value: ("01_D"),
  },
  {
    key: 2,
    value: ("02_D"),
  },
  {
    key: 3,
    value: ("03_D"),
  },
  {
    key: 4,
    value: ("01_D"),
  },
  {
    key: 5,
    value: ("05_D"),
  },
  {
    key: 6,
    value: ("06_D"),
  },
  {
    key: 7,
    value: ("07_D"),
  },
  {
    key: 8,
    value: ("08_D"),
  },
  {
    key: 9,
    value: ("09_D"),
  },
  {
    key: 10,
    value: ("10_D"),
  },
  {
    key: 11,
    value: ("11_D"),
  },
  {
    key: 12,
    value: ("12_D"),
  },
  {
    key: 13,
    value: ("13_D"),
  },
  {
    key: 14,
    value: ("14_D"),
  },
  {
    key: 15,
    value: ("15_D"),
  },
  {
    key: 16,
    value: ("16_D"),
  },
  {
    key: 17,
    value: ("17_D"),
  },
  {
    key: 18,
    value: ("18_D"),
  },
  {
    key: 19,
    value: ("19_D"),
  },
  {
    key: 20,
    value: ("20_D"),
  },
  {
    key: 21,
    value: ("21_D"),
  },
  {
    key: 22,
    value: ("22_D"),
  },
  {
    key: 23,
    value: ("23_D"),
  },
  {
    key: 24,
    value: ("24_D"),
  },
  {
    key: 25,
    value: ("25_D"),
  },
  {
    key: 26,
    value: ("26_D"),
  },
  {
    key: 27,
    value: ("27_D"),
  },
  {
    key: 28,
    value: ("28_D"),
  },
  {
    key: 29,
    value: ("29_D"),
  },
  {
    key: 30,
    value: ("30_D"),
  },
  {
    key: 31,
    value: ("31_D"),
  },
];
/* eslint-disable */
self.REQUIRED_PATTERNS = [
  /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?{}\[\]~@^_|]{6,}$/,
];

self.BANK_STATUS = {
  DEFAULT_BANK_STATUS: "0",
  WAITING: "1",
  APPROVED: "4",
  REJECTED: "5",
  RECHECKING: "6",
};

self.VERIFY_BANK_STATUS = {
  DEFAULT_VERIFY_BANK_STATUS: "0",
  VERIFIED: "1",
  NOT_VERIFIED: "2",
};

self.AGREEMENT_NEWS_MODAL_TYPE={
  CANCEL:"cancel",
  LEND:"lend",
  PEP:"pep"
};
self.CRYPTO_PAGE= {
  STATIC_PAGE_1: "/index#/static-page-1",
  STATIC_PAGE_2: "/index#/static-page-2",
  STATIC_PAGE_3: "/index#/static-page-3",
  STATIC_PAGE_4: "/index#/static-page-4",
  UPLOAD_DOCUMENT: "/index#/mynumber"
};
self.LINK_ASSETS= {
  CRYPTO_LOGO: require("@/assets/img/cryptlogo.svg"),
  BO_BLOCK_LOGO: require("@/assets/img/bo-block-logo.svg")
};

self.WEB_LINK= {
  MIN_ST_HOME: Config.getMinStHome(),
  SUPPORT_FAQ_URL: Config.getSupportFAQUrl(),
};

self.SERVICE_NAME= {
  BANK_ACCOUNT: "bankAccount",
  BO_REGISTRATION: "boRegistration",
  CRYPTO_REGISTRATION: "cryptoRegistration",
  DEPOSIT: "deposit",
  PROFILE: "profile",
  WITHDRAWAL: "withdrawal",
  AUTH: "auth",
  FORCE_NEWS: "forceNews",
  FIDO: "fido"
};

self.BO_PAGE= {
  BO_REGISTER: "BO.Register"
};

self.leftMenuItems = [
    {
        link: {name: "home"},
        cssClass: "fa fa-fw fa-home",
        text: "trs.front.title.left.menu.dashboard",
        active: false,
        id: "dashboard",
    },
    {
        link: {name: "deposit"},
        cssClass: "fa fa-fw fa-university",
        text: "trs.front.title.left.menu.deposit",
        active: false,
        id: "deposit",
    },
    {
        link: {name: "withdrawal"},
        cssClass: "fa fa-fw fa-yen-sign",
        text: "trs.front.title.left.menu.withdraw",
        active: false,
        id: "withdrawal",
    },
    {
        link: {name: "transfer"},
        cssClass: "fa fa-fw fa-exchange-alt",
        text: "trs.front.title.left.menu.transfer",
        active: false,
        id: "transfer",
    },
    {
        link: {name: "history"},
        cssClass: "fa fa-fw fa-history",
        text: "trs.front.title.left.menu.history",
        active: false,
        id: "history",
    },
    {
        link: {name: "report"},
        cssClass: "far fa-fw fa-file-alt",
        text: "trs.front.title.left.menu.reports",
        active: false,
        id: "report",
    },
    {
        link: {name: "performance"},
        href: Config.getMyPerformanceLink(),
        cssClass: "fa fa-fw fa-chart-bar",
        text: "trs.front.title.left.menu.my_performance",
        active: false,
        id: "performance",
    },
    {
        link: {name: "editProfile"},
        cssClass: "fa fa-fw fa-user",
        text: "trs.front.title.left.menu.account_info",
        active: false,
        id: "edit-profile",
    },
    {
        link: {name: "customerSupport"},
        cssClass: "fa fa-fw fa-question",
        text: "trs.front.title.left.menu.support",
        active: false,
        id: "customer-support",
    },
];

self.API_MESSAGE_TYPE = {
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
    WARNING: "WARNING",
    FAIL: "FAIL",
    NEED_RELOAD_PAGE: "NEED_RELOAD_PAGE"
};

self.HISTORY_ENUMS = {
  PAGE: "page",
  CANCEL: "cancel",
  HISTORY_SERVICE: 'history',
};

self.E_CONFIRM_SCREEN = {
  DEPOSIT_VERITRANS: "_DEPOSIT_VERITRANS",
  WITHDRAWAL_BANK: "_WITHDRAWAL_BANK",
  WITHDRAWAL_BRANCH: "_WITHDRAWAL_BRANCH",
  WITHDRAWAL_CANCEL: "_WITHDRAWAL_CANCEL",
  HISTORY_CANCEL: "_HISTORY_CANCEL"
};

self.PARENT_SCREEN = {
  FORCE_NEWS: "force-news",
  EDIT_PROFILE: "edit-profile"
};

// these values are based on real values which BE add to database
self.FORCE_NEW_TYPE = {
  FORCE_ON: 1,
  ON: 0,
  EMPTY: -1,
  NOT_FORCE_NEW_TYPE: -2
};

// these values are based on real values which BE add to database
self.FORCE_NEW_DISPLAY_FORM_CODE = {
  ADDRESS: 'ADD',
  PASSWORD: 'PWD',
  TFA: 'AUT',
};

self.MARK_AS_READ_CLASS = {
  READ: 'read',
  UNREAD: 'unread'
};

self.CONFIRM_MAIL = {
  TITLE: "メール認証",
  DEFAULT_SUCCESS_MESSAGE: "ご登録のメールアドレスの認証が完了しました。",
  TITLE_BUTTON_GO_BACK_MY_PAGE: "マイページにログインする",
};

self.SESSION_ID = 'SESSION';

self.EVENT_NAME = {
  ON_CONFIRM_AGREEMENT_WEBKIT: "onConfirmAgreementWebkit",
  SHOW_AGREEMENT_NEWS_MODAL: "showAgreementNewsModal",
  OPEN_BO_REGISTRATION_CANCEL_MODAL: "openBoRegistrationCancelModal",
  OPEN_CANCEL_MODAL: "openCancelModal",
  SHOW_AGE_LIMIT_MSG: "showAgeLimitMsg",
  SHOW_BO_AGE_LIMIT_MSG: "showBoAgeLimitMsg",
  OPEN_CRYPTO_REGISTRATION_CANCEL_MODAL: "openCryptoRegistrationCancelModal",
  OPEN_INFORM_MODAL: "openInformModal",
  MODAL_CONFIRM: "modalConfirm",
  OPEN_SERVER_ERROR_MODAL: "openServerErrorModal",
  CLOSE_SERVER_ERROR_MODAL: "closeServerErrorModal",
  SHOW_NEWS_INFO: "showNewsInfo",
  OPEN_SEARCH_BANK: "openSearchBank",
  CLOSE_MODAL_CONFIRM: "closeModalConfirm",
  SEARCH_BANK_VERITRANS: "searchBankVeritrans",
  OPEN_SEARCH_BRANCH: "openSearchBranch",
  OPEN_TEST_DISABLED_MODAL: "openTestDisabledModal",
  CLOSE_INFORM_MODAL: "closeInformModal",
  CLOSE_TEST_DISABLED_MODAL: "closeTestDisabledModal",
  GET_SELECTED_BANK: "getSelectedBank",
  AFTER_SELECT_BANK: "afterSelectBank",
  AFTER_SELECT_BRANCH: "afterSelectBranch",
  OPEN_UNSUPPORTED_BROWSER_MODAL: "openUnsupportedBrowserModal",
  AUTH_SECOND_PASS: "isAuthPass2",
  SHOW_PROFILE_MESSAGE: "showProfileMessage",
  SCREEN_ALREADY_AUTH_SECOND_PASS: "isScreenAlreadyAuthenPass2",
  REPORT_MESSAGES: "reportMessages",
  POPUP_SECOND_PASS_VISIBLE: "isPopup2FaVisible",
  SHOW_REGISTER_PASSKEY_RESULT: "showRegisterPasskeyResult",
  RETRY_REGISTER_PASSKEY_RESULT: "retryRegisterPasskeyResult",
  CLOSE_REGISTER_PASSKEY_SUCCESS: "closeRegisterPasskeySuccess",
  MASKING_VERIFY_RESULT: "maskingVerifyResult",
  SHOW_OTP_MAIL_CHOOSING: "showOtpMailChoosing",
  SHOW_OTP_INPUT: "showOtpInput",
  SHOW_OTP_INPUT_RESULT: "showOtpInputResult",
  CLOSE_OTP_INPUT_RESULT: "closeOtpInputResult",
  SHOW_FIDO_AUTHENTICATE_UNSUPPORTED: "showFidoAuthenticateUnsupported",
  SHOW_CONFIRM_DELETE_PASSKEY: "showConfirmDeletePasskey",
  SHOW_DELETE_PASSKEY_RESULT: "showDeletePasskeyResult",
  SHOW_REGISTER_PASSKEY_MODAL: "showRegisterPasskeyModal",
  HIDE_REGISTER_PASSKEY_MODAL: "hideRegisterPasskeyModal",
  SHOW_REGISTER_PASSKEY_MODAL_RESULT: "showRegisterPasskeyModalResult",
  RETRY_REGISTER_PASSKEY_MODAL_RESULT: "retryRegisterPasskeyModalResult",
  RELOAD_REGISTERED_PASSKEYS: "reloadRegisteredPasskeys",
  RE_ASSIGN_PROFILE_STATE_EVENT: "reAssignProfileStateEvent",
  RE_ASSIGN_PROFILE_STATE_AND_RE_EMIT_MASKING_VERIFIED_EVENT: "reAssignProfileStateAndReEmitMaskingVerifiedEvent"
};

self.PW_NUMBER_ONLY   = /^[0-9]+$/
self.PW_LOWER_ONLY    = /^[a-z]+$/
self.PW_UPPER_ONLY    = /^[A-Z]+$/
self.PW_SPECIAL_ONLY  = /^[!"#$%&'()*+,\-.\/:;<=>?{}\[\]~@^_|]+$/
self.PW_PATTERN_VALID = /^[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?{}\[\]~@^_|]{10,64}$/
self.PW2_PATTERN_VALID = /^[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?{}\[\]~@^_|]{4,64}$/

self.HAVE_NUMBER        = /^(?=.*[0-9]).*$/
self.HAVE_LOWER         = /^(?=.*[a-z]).*$/
self.HAVE_UPPER         = /^(?=.*[A-Z]).*$/
self.HAVE_SPECIAL_CHARS = /^(?=.*[!"#$%&'()*+,\-.\/:;<=>?{}\[\]~@^_|]).*$/
self.PW_PATTERN_VALID_EA = /^[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?{}\[\]~@^_|]{10,16}$/

self.MAX_LENGTH = {
  VALIDATE_PASSWORD: 4
}

self.VALIDATE_PASSWORD = {
  CHECK_MAIL: "@"
}

self.VALIDATE_PASSWORD_CONFIG_VALUE = 1;

self.STATUS_CODES = {
  CONTINUE: 100,
  SWITCHING_PROTOCOLS: 101,
  PROCESSING: 102,
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE_INFORMATION: 203,
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,
  MULTI_STATUS: 207,
  MULTIPLE_CHOICES: 300,
  MOVED_PERMANENTLY: 301,
  MOVED_TEMPORARILY: 302,
  SEE_OTHER: 303,
  NOT_MODIFIED: 304,
  USE_PROXY: 305,
  TEMPORARY_REDIRECT: 307,
  PERMANENT_REDIRECT: 308,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  REQUEST_TOO_LONG: 413,
  REQUEST_URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYPE: 415,
  REQUESTED_RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  IM_A_TEAPOT: 418,
  INSUFFICIENT_SPACE_ON_RESOURCE: 419,
  METHOD_FAILURE: 420,
  MISDIRECTED_REQUEST: 421,
  UNPROCESSABLE_ENTITY: 422,
  LOCKED: 423,
  FAILED_DEPENDENCY: 424,
  PRECONDITION_REQUIRED: 428,
  TOO_MANY_REQUESTS: 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
  UNAVAILABLE_FOR_LEGAL_REASONS: 451,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505,
  INSUFFICIENT_STORAGE: 507,
  NETWORK_AUTHENTICATION_REQUIRED: 511
}

self.SCREEN_NAME = {
  HEADER: 'HEADER',
  CUSTOMER_INFO: 'CUSTOMER_INFO',
  WITHDRAWAL: 'WITHDRAWAL',
  CUSTOMER_REPORT: 'CUSTOMER_REPORT'
}

self.ROUTER_NAME = {
  EDIT_PROFILE: "editProfile",
  WITHDRAWAL: "withdrawal",
  REPORT: "report",
  HOME: "home",
  INDEX: "index"
}

self.VALUE_FOR_CHECKBOX = {
  TRUE_VALUE : '1',
  FALSE_VALUE : '0',
}

self.SYSTEM_CONFIG_KEY = {
  REPORT_TEMPLATE : 'REPORT_TEMPLATE_'
}

self.JASPER_TEMPLATE = {
  CD_POST_DOC: 'CD_POST_DOC',
  POST_DOC_ZIP_CODE: 'postDocZipCode',
  POST_DOC_STREET_ADDRESS: 'postDocStreetAddress',
  POST_DOC_BUILDING_ADDRESS: 'postDocBuildingAddress',
  POST_DOC_TELEPHONE: 'postDocTelephone',
  POST_DOC_EMAIL: 'postDocEmail',
  POST_DOC_COMPANY_NAME: 'postDocCompanyName'
}

self.MAX_FILE_UPLOAD = {
  UPLOAD_ID_DOCUMENT: 5
}

self.YES_NO = {
  YES: '1',
  NO: '0'
}

self.AUTH_TYPE = {
  OTP: 1,
  PASSKEY: 2
}

self.PASSKEY_STATUS = {
  UNSET_YET: 0,
  ALREADY_SET: 1
}

self.MAIL_OTP = {
  MAIN_MAIL: 1,
  ADDITIONAL_MAIL: 2
}

self.ACTIVE_MASKING = {
  NO: 0,
  YES: 1
}

self.CUSTOM_PARAM = {
  APP_SOURCE_TYPE: 'app-source-type',
  X_SOURCE_ID: 'x-source-id'
}

self.APP_SOURCE_TYPE = {
  NTD_FX: 'NTD_FX',
  NTD_FX_IOS: 'NTD_FX_IOS',
  NTD_FX_ANDROID: 'NTD_FX_ANDROID',
  CRYPT_CFD: 'CRYPT_CFD',
  CRYPT_CFD_IOS: 'CRYPT_CFD_IOS',
  CRYPT_CFD_ANDROID: 'CRYPT_CFD_ANDROID',
  COPY_TRADE: 'COPY_TRADE',
  COPY_TRADE_IOS: 'COPY_TRADE_IOS',
  COPY_TRADE_ANDROID: 'COPY_TRADE_ANDROID'
}

export default self;
